import styled from 'styled-components';

export const Overlay = styled.div`
  cursor: initial;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: var(--cco-surface);
  width: ${(props) => props.width || 'min(1100px, 92vw)'};
  max-height: 90vh;
  overflow-y: auto;
  padding: clamp(20px, 3vw, 36px) clamp(24px, 4vw, 48px);
  border-radius: 14px;
  z-index: 21;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
  border: 1px solid var(--cco-line);
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 44px;
`;

export const CloseRow = styled.div`
  display: none;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: transparent;
  color: var(--cco-ink-mute);
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-size: ${(props) => props.theme.fontSizes.xs};
  border: 1px solid var(--cco-line);
  z-index: 2000;
  cursor: pointer;
  transition: transform ${(props) => props.theme.transitions.fast},
    background 150ms, color 150ms, border-color 150ms;

  :hover {
    cursor: pointer;
    transform: scale(1.1);
    background: var(--cco-soft-surface);
    border-color: var(--cco-line-strong);
    color: var(--cco-ink);
  }
`;

export const Title = styled.h2`
  color: var(--cco-ink);
  font-size: ${(props) => props.theme.fontSizes.display};
  line-height: 1.2;
  margin: 0;
  font-weight: ${(props) => props.theme.fontWeights.bold};
`;

export const Subtitle = styled.span`
  color: var(--cco-ink-faint);
  font-size: ${(props) => props.theme.fontSizes.lg};
  margin-top: ${(props) => props.theme.spacing.sm};
`;

export const RequiredHint = styled.span`
  color: ${(props) =>
    props.unfilled ? 'var(--cco-red)' : 'var(--cco-ink-faint)'};
  font-size: ${(props) => props.theme.fontSizes.xs};
  margin-top: ${(props) => props.theme.spacing.sm};
`;
